import React from 'react';
import cateringImg from '../assets/images/catring_2.webp';
import bathImg from '../assets/images/Spa-7.webp';
import shopsImg from '../assets/images/Shoping.webp';
import conferenceImg from '../assets/images/hall_9.webp';
import football from '../assets/images/Garden-1.webp';

const services = [
  {
    title: {
      en: '🎂 Event Catering',
      am: '🎂 የዝግጅት ምግብ አቅራቢ'
    },
    image: cateringImg,
    description: {
      en: `We offer full-service catering for weddings, birthdays, graduations, and corporate events. Our chefs prepare everything from traditional Ethiopian dishes to international cuisine — tailored to your preferences and budget.

We also offer coffee ceremonies, buffet setups, server staff, and personalized menu planning.`,
      am: `ለጋብቻ፣ ልደት፣ ምረቃ እና የቢዝነስ ዝግጅቶች ሙሉ የምግብ አቅርቦት እናቀርባል። አሰራሮቻችን ከባህላዊ የኢትዮጵያ ምግቦች እስከ ዓለም አቀፍ ምግቦች ድረስ - በእርስዎ ምርጫ እና በጀት ይዘጋጃል።

የቡና ስነስርዓት፣ ቡፌ ማዘጋጃ ቤት፣ አገልጋዮች እና የተጠናቀቀ የምግብ ዝርዝር እቅድ እናቀርባል።`
    }
  },
  {
    title: {
      en: '🛁 Moroccan Bath',
      am: '🛁 የሞሮኮ መታጠቢያ'
    },
    image: bathImg,
    description: {
      en: `Our Moroccan bath combines steam, scrubbing, and massage using natural oils and clays. The treatment detoxifies the skin, improves circulation, and leaves you completely refreshed.

Facilities include private rooms, professional attendants, and premium hygiene standards.`,
      am: `የእኛ የሞሮኮ መታጠቢያ እንፋሎት፣ ማጠቢያ እና ጡብ ማገዶን የተፈጥሮ ዘይቶች እና ከሸክላ ጋር ያጣምራል። ሕክምናው ቆዳውን ያነጻል፣ የደም ዝውውርን ያሻሽላል እና ሙሉ በሙሉ እንደገና ይመልሳል።

በግላዊ ክፍሎች፣ ባለሙያ አገልጋዮች እና ከፍተኛ የንፅህና ደረጃዎች ይገኛል።`
    }
  },
  {
    title: {
      en: '🛍️ On-site Shops',
      am: '🛍️ በቦታው ላይ ያሉ ሱቆች'
    },
    image: shopsImg,
    description: {
      en: `Our shopping wing includes:

- A Sport Jersey Shop with authentic local and international kits
- A Beauty Salon for haircuts, facials, and grooming
- A Photo Studio offering instant portraits and event coverage

All shops are located within the club compound for convenience.`,
      am: `የእኛ የግዢ ክፍል የሚከተሉትን ያካትታል:

- የስፖርት ጄርሲ ሱቅ
- የውበት ሳሎን ለፀጉር፣ ፊት እና ለጽዳት
- ፎቶ ስቱዲዮ ፈጣን የፎቶ ስራ እና የዝግጅት ከፍል

ሁሉም ሱቆች በአስተማማኝነት በክለቡ ውስጥ ይገኛሉ።`
    }
  },
  {
    title: {
      en: '🏢 VIP Conference Rooms',
      am: '🏢 ቪአይፒ የስብሰባ ክፍሎች'
    },
    image: conferenceImg,
    description: {
      en: `Designed for high-end meetings, our VIP conference rooms feature:

- Modern furnishings and privacy
- Projector, Wi-Fi, whiteboard, and mic system
- Capacity for up to 60 people

Perfect for business summits, team workshops, and executive sessions.`,
      am: `ለከፍተኛ ስብሰባዎች የተነደፉ፣ የእኛ ቪአይፒ የስብሰባ ክፍሎች የሚከተሉትን ያቀርባሉ:

- ዘመናዊ ዕቃዎች እና ግላዊ ይዞታ
- ፕሮጀክተር፣ ዋይፋይ፣ ነጭ ሰሌዳ እና የማይክራፎን ስርዓት
- እስከ 60 ሰዎች የሚያስተናግድ

ለንግድ ጉባኤዎች፣ የቡድን ስልጠናዎች እና የአስፈጻሚ ስብሰባዎች ተስማሚ።`
    }
  },
  {
  title: {
    en: '🏟️ Football Field Rent',
    am: '🏟️ የእግር ኳስ ሜዳ ኪራይ'
  },
  image: football,
  description: {
    en: `Our football field is available for rent — ideal for:

- Team practices and local tournaments
- Friendly matches and sports events
- School or corporate leagues
- Special sports day events

The facility offers ample space, maintained turf, locker rooms, and optional lighting for evening games.`,
    am: `የእግር ኳስ ሜዳችን ለኪራይ ይገኛል — ለሚከተሉት ተስማሚ:

- የቡድን ልምምዶች እና የአስፖርት ውድድሮች
- ወዳጅነት ጨዋታዎች እና የስፖርት ዝግጅቶች
- የትምህርት ቤት ወይም የኩባንያ ሊጎች
- ልዩ የስፖርት ቀን ዝግጅቶች

መሳሪያው ሰፊ ቦታ፣ የተጠረበ ሜዳ፣ የሎከር ክፍሎች እና ለምሽታዊ ጨዋታዎች አማራጭ መብራት ያቀርባል።`
  }
}
];

const OtherServicesDetail = ({ language }) => {
  return (
    <>
      <section className="container py-5">
        <h1 className="fw-bold text-center mb-5">
          {language === 'am' ? 'ሌሎች አገልግሎቶች በዝርዝር' : 'Other Services in Detail'}
        </h1>

        {services.map((service, index) => (
          <div key={index} className="row align-items-center mb-5">
            {/* IMAGE COLUMN */}
            <div className="col-md-5 mb-3 mb-md-0">
              <img
                src={service.image}
                alt={language === 'am' ? service.title.am : service.title.en}
                className="img-fluid rounded shadow-sm"
                style={{ height: '260px', objectFit: 'cover', width: '100%' }}
              />
            </div>

            {/* TEXT COLUMN */}
            <div className="col-md-7">
              <h2 className="fw-bold mb-3">
                {language === 'am' ? service.title.am : service.title.en}
              </h2>
              <p className="text-muted" style={{ whiteSpace: 'pre-line' }}>
                {language === 'am' ? service.description.am : service.description.en}
              </p>
            </div>
          </div>
        ))}

      </section>
    </>
  );
};

export default OtherServicesDetail;
